import { useMemo, useState } from "react";
import { Users, X } from "lucide-react";
import { roleLabel } from "./chatUtils";

export function NewConversationModal({ users, currentUserId, onClose, onCreate }) {
  const [mode, setMode] = useState("direct");
  const [selected, setSelected] = useState([]);
  const [name, setName] = useState("");
  const available = useMemo(() => users.filter((u) => u.id !== currentUserId), [users, currentUserId]);

  const toggle = (id) => {
    if (mode === "direct") {
      setSelected([id]);
      return;
    }
    setSelected((prev) => prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]);
  };

  const canCreate = selected.length >= 1 && (mode === "direct" || selected.length >= 1);

  return (
    <div data-testid="chat-new-conversation-modal" className="fixed inset-0 z-[80] bg-black/35 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-xl border border-[#DCD7CE] shadow-2xl overflow-hidden">
        <div className="px-5 py-4 border-b border-[#DCD7CE] flex items-center justify-between">
          <div className="flex items-center gap-2 font-heading text-lg font-semibold text-[#0B2230]"><Users className="w-5 h-5" /> Nova conversa</div>
          <button data-testid="chat-new-conversation-close-button" onClick={onClose} className="w-8 h-8 rounded-lg hover:bg-[#F4F1EA] grid place-items-center" aria-label="Fechar">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="p-5 space-y-4">
          <div className="grid grid-cols-2 gap-2 rounded-lg bg-[#F4F1EA] p-1">
            <button data-testid="chat-new-direct-tab-button" onClick={() => { setMode("direct"); setSelected([]); }} className={`rounded-md px-3 py-2 text-sm ${mode === "direct" ? "bg-white shadow-sm" : "text-[#5C6B73]"}`}>1:1</button>
            <button data-testid="chat-new-group-tab-button" onClick={() => { setMode("group"); setSelected([]); }} className={`rounded-md px-3 py-2 text-sm ${mode === "group" ? "bg-white shadow-sm" : "text-[#5C6B73]"}`}>Grupo</button>
          </div>
          {mode === "group" && (
            <input
              data-testid="chat-new-group-name-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Nome do grupo"
              className="w-full rounded-lg border border-[#DCD7CE] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#0B2230]/20"
            />
          )}
          <div className="max-h-72 overflow-y-auto space-y-1">
            {available.map((member) => {
              const active = selected.includes(member.id);
              return (
                <button
                  key={member.id}
                  data-testid={`chat-new-conversation-user-${member.id}-button`}
                  onClick={() => toggle(member.id)}
                  className={`w-full flex items-center gap-3 rounded-lg border px-3 py-2 text-left transition-colors ${active ? "border-[#0B2230] bg-[#F4F1EA]" : "border-[#DCD7CE] hover:bg-[#F8F5EF]"}`}
                >
                  <span className="w-8 h-8 rounded-full bg-[#0B2230] text-white grid place-items-center text-xs font-semibold">{member.name?.[0]?.toUpperCase() || "U"}</span>
                  <span className="min-w-0 flex-1">
                    <span className="block text-sm font-medium text-[#0B2230] truncate">{member.name}</span>
                    <span className="block text-xs text-[#5C6B73] truncate">{roleLabel(member.role)} · {member.email}</span>
                  </span>
                </button>
              );
            })}
          </div>
        </div>
        <div className="px-5 py-4 border-t border-[#DCD7CE] flex justify-end gap-2 bg-[#F8F5EF]">
          <button data-testid="chat-new-conversation-cancel-button" onClick={onClose} className="px-4 py-2 rounded-lg border border-[#DCD7CE] text-sm hover:bg-white">Cancelar</button>
          <button
            data-testid="chat-new-conversation-create-button"
            disabled={!canCreate}
            onClick={() => onCreate({ type: mode, participant_ids: selected, name })}
            className="px-4 py-2 rounded-lg bg-[#0B2230] text-white text-sm hover:bg-[#143346] disabled:opacity-40 disabled:cursor-not-allowed"
          >
            Criar
          </button>
        </div>
      </div>
    </div>
  );
}